import { render, staticRenderFns } from "./abnormalDetails.vue?vue&type=template&id=5b63f150&scoped=true&"
import script from "./abnormalDetails.vue?vue&type=script&lang=js&"
export * from "./abnormalDetails.vue?vue&type=script&lang=js&"
import style0 from "./abnormalDetails.vue?vue&type=style&index=0&id=5b63f150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63f150",
  null
  
)

export default component.exports